/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import * as R from 'ramda';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'reactstrap';
import { PagingComponent } from '../../../reactutils/withPagination';
import { SearchComponent } from '../../../reactutils/withSearch';
import { withTitle } from '../../../reactutils/withTitle';
import { Song } from '../../../services/playlist';
import { LoadingIndicatorContent } from '../../common/LoadingIndicatorSpinner';
import { SongLink } from '../SongLink';
import {
    searchSong,
    songListBackward,
    songListFastBackward,
    songListFastForward,
    songListForward,
    songListSearch
} from './actions';
import {
    songList,
    songListIsLoading,
    songListSearchString,
    songSearchCount,
    songSearchCurrentPos,
    songSearchPageSize
} from './selectors';

function showSong(song: Song, isLoading: boolean) {
    return (
        <tr key={song.id} className="d-flex">
            <td className="col-5">
                <LoadingIndicatorContent isLoading={isLoading}>
                    <SongLink songId={song.id}>{song.artist}</SongLink>
                </LoadingIndicatorContent>
            </td>
            <td className="col-5">
                <LoadingIndicatorContent isLoading={isLoading}>
                    <SongLink songId={song.id}>{song.name}</SongLink>
                </LoadingIndicatorContent>
            </td>
            <td className="col-2">{song.audioUrl && 'Audio'}</td>
        </tr>
    );
}

const SongList: React.FC<{}> = () => {
    const dispatch = useDispatch();
    const songs = useSelector(songList);
    const isLoading = useSelector(songListIsLoading);

    React.useEffect(() => {
        dispatch(searchSong());
    }, [dispatch]);

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap">
                <SearchComponent
                    onSearch={s => songListSearch(s)}
                    searchResultCountSelector={songSearchCount}
                    searchStringSelector={songListSearchString}
                />
                <PagingComponent
                    onBackward={() => songListBackward()}
                    onFastBackward={() => songListFastBackward()}
                    onFastForward={() => songListFastForward()}
                    onForward={() => songListForward()}
                    searchResultCount={songSearchCount}
                    searchResultCurrentPos={songSearchCurrentPos}
                    searchResultPageSize={songSearchPageSize}
                />
            </div>
            <Table striped={true} className="mt-2">
                <thead>
                    <tr className="d-flex">
                        <th className="col-5">Artist</th>
                        <th className="col-5">Title</th>
                        <th className="col-2">Audio</th>
                    </tr>
                </thead>
                <tbody>{songs && songs.map(s => showSong(s, isLoading))}</tbody>
            </Table>
        </>
    );
};

export default R.compose(withTitle('Song-Datenbank'))(SongList);
